import { render, staticRenderFns } from "./DEXT5Editor.vue?vue&type=template&id=5d7717c5&scoped=true"
import script from "./DEXT5Editor.vue?vue&type=script&lang=js"
export * from "./DEXT5Editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7717c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d7717c5')) {
      api.createRecord('5d7717c5', component.options)
    } else {
      api.reload('5d7717c5', component.options)
    }
    module.hot.accept("./DEXT5Editor.vue?vue&type=template&id=5d7717c5&scoped=true", function () {
      api.rerender('5d7717c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DEXT5Editor.vue"
export default component.exports